import {
  appendIntegrationToIntegrationMap,
  generateIntegrationMap,
} from '../../../common/util/integrationReducerUtil';
import {
  fetchIntegrations,
  fetchIntegretionMetaData,
} from '../../routines/integrations/integrationDataRoutines';
import {
  showDisconnectModal,
  showConnectModal,
  connectIntegration,
  disconnectIntegration,
  requiredGrantErrorMessage,
} from '../../routines/integrations/integrationSetupRoutines';
import { disconnectIntegration as zendeskIntegrationDisconnect } from '../../routines/integrations/zendeskRoutines';

const initialState = {
  showConnectModal: false,
  showDisconnectModal: false,
  id: null,
  integrations: {},
  metadata: {},
  loading: false,
  metadataLoading: false,
};

/**
 * Common integration reducer
 * All the integration data, and connect modal status are stored here
 * @param {*} state
 * @param {*} action
 * @returns
 */
const integrationSetupReducer = (state = initialState, action) => {
  switch (action.type) {
    case showConnectModal.TRIGGER:
      return {
        ...state,
        showConnectModal:
          !action.payload.integrationStatus && action.payload.show,
        id: action.payload.id,
      };
    case showDisconnectModal.TRIGGER:
      return {
        ...state,
        showDisconnectModal: action.payload.show,
        id: action.payload.id,
      };
    case connectIntegration.TRIGGER:
      return {
        ...state,
        loading: true,
        integration: null,
        error: null,
      };
    case fetchIntegretionMetaData.TRIGGER:
      return {
        ...state,
        metadataLoading: true,
        metaData: null,
        error: null,
      };
    case fetchIntegrations.TRIGGER:
    case disconnectIntegration.TRIGGER:
    case zendeskIntegrationDisconnect.TRIGGER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case fetchIntegrations.SUCCESS: {
      const { user, tenant } = action.payload;
      return {
        ...state,
        loading: false,
        error: null,
        integrations: generateIntegrationMap([...user, ...tenant]),
      };
    }
    case connectIntegration.SUCCESS: {
      const { integrationType, type, vendor, integration } = {
        ...action.payload,
      };
      const currentIntegrations = { ...state.integrations };
      return {
        ...state,
        loading: false,
        integrations: appendIntegrationToIntegrationMap(
          currentIntegrations,
          integrationType,
          type,
          vendor,
          integration
        ),
      };
    }
    case fetchIntegretionMetaData.SUCCESS: {
      return {
        ...state,
        metadataLoading: false,
        metadata: { ...state.metadata, ...action.payload },
      };
    }
    case fetchIntegrations.FAILURE:
    case connectIntegration.FAILURE: {
      const { error } = action?.payload;
      return {
        ...state,
        loading: false,
        error,
        showConnectModal: false,
        id: null,
      };
    }
    case fetchIntegretionMetaData.FAILURE: {
      const { error } = action?.payload;
      return {
        ...state,
        metadataLoading: false,
        error,
        showConnectModal: false,
        id: null,
      };
    }
    case disconnectIntegration.SUCCESS:
    case zendeskIntegrationDisconnect.SUCCESS:
    case disconnectIntegration.FAILURE:
    case zendeskIntegrationDisconnect.FAILURE:
      return {
        ...state,
        showDisconnectModal: false,
        loading: false,
        id: null,
      };
    case requiredGrantErrorMessage.FAILURE:
    default:
      return state;
  }
};

export default integrationSetupReducer;
